import React from "react";
import { mdiFileExcel } from "@mdi/js";
import Icon from "@mdi/react";
import { Tooltip, Typography, Button } from "@material-ui/core";
import Styled from "styled-components";
import { Wrapper } from "../../Control/Flexbox";
import PrintIcon from "@material-ui/icons/Print";
import formatDate from "../../Control/formatDate";
import { CenteredLogoImg } from "../../../golbalStyles/global.styled";
import { images, textInputs } from "../../../constants/constants";
import TableToExcel from "@dayalk/table-to-excel";
const Table = Styled.table`
	width:98%;
	margin:0.7rem auto;
	 border: 1px solid black;


    th{
        font-size: 13px;
		font-family:"Roboto",sans-serif;
        border: 1px solid black;
        padding: 0.4rem;
        p{
          margin:0;
        }
    }
    td{
        font-size: 13px;
        border: 1px solid black;
        padding: 0.3rem;
        p{
          margin:0;
        }
    }
    span{
        font-weight: 400;
    }
`;
const CheckingAids = ({ ppapData }) => {
  function printTable() {
    var divToPrint = document.getElementById("table-to-xls");
    let newWin = window.open("");
    newWin.document.write(divToPrint.outerHTML);
    newWin.print();
    newWin.close();
  }
  return (
    <section>
      <div className="divflex">
        <Typography
          style={{
            fontSize: "24px",
            fontFamily: "Nunito",
          }}
        >
          CHECKING AIDS
        </Typography>
        <Wrapper>
          <Tooltip arrow title="Print table">
            <PrintIcon
              style={{
                color: "white",
                cursor: "pointer",
                fontSize: "1.9rem",
                marginRight: "0.6rem",
              }}
              onClick={printTable}
            />
          </Tooltip>
          <Tooltip arrow title="Export as spreadsheet">
            <div>
              <Button
                style={{
                  backgroundColor: "#161a1d",
                  borderColor: "#161a1d",
                  borderRadius: "0",
                  color: "white",
                  width: "fit-content",
                }}
                onClick={() => {
                  TableToExcel.convert(
                    document.getElementById("table-to-xls"),
                    {
                      name: "checking_aids.xlsx",
                      sheet: {
                        name: "Checking Aids",
                      },
                    }
                  );
                }}
              >
                <Icon path={mdiFileExcel} size={1.2} />
              </Button>
            </div>
          </Tooltip>
        </Wrapper>
      </div>
      <div style={{ paddingBottom: "4rem" }}>
        <Table
          cellSpacing="0"
          id="table-to-xls"
          data-default-wrap="true"
          data-cols-width="10, 40, 30, 21, 27, 20"
        >
          <thead>
            <tr>
              <th
                colSpan="4"
                align="left"
                rowSpan={4}
                style={{
                  border: "1px solid black",
                  fontSize: "1.6rem",
                  textAlign: "center",
                }}
                data-a-v="middle"
              >
                <CenteredLogoImg>
                  <img src={images.CompanyLogo} alt={textInputs.companyName} />
                  <span>{textInputs.companyName}</span>
                </CenteredLogoImg>
              </th>
              <th align="left" style={{ border: "1px solid black" }}>
                Format No:
              </th>
              <th align="left" style={{ border: "1px solid black" }}>
                F APQP 08
              </th>
            </tr>
            <tr>
              <th align="left" style={{ border: "1px solid black" }}>
                ISSUE DATE:
              </th>
              <th align="left" style={{ border: "1px solid black" }}>
                April 19
              </th>
            </tr>
            <tr>
              <th align="left" style={{ border: "1px solid black" }}>
                REVISION NO:
              </th>
              <th align="left" style={{ border: "1px solid black" }}>
                00
              </th>
            </tr>
            <tr>
              <th align="left" style={{ border: "1px solid black" }}>
                REVISION DATE:
              </th>
              <th align="left" style={{ border: "1px solid black" }}>
                00
              </th>
            </tr>

            <tr>
              <td
                colSpan="6"
                align="center"
                style={{
                  fontSize: "1.2rem",
                  fontWeight: 600,
                  backgroundColor: "#1d1d1d",
                  color: "white",
                  border: "1px solid black",
                }}
                data-font-sz="18"
                data-a-h="center"
                data-f-bold="true"
                data-fill-color="#1d1d1d"
                data-f-color="FFFFFF"
              >
                CHECKING AIDS
              </td>
            </tr>

            <tr>
              <td
                align="right"
                colSpan={6}
                style={{
                  border: "1px solid black",
                  textAlign: "right",
                }}
              >
                DOC. NO.: SLF APQP 01
              </td>
            </tr>
            <tr>
              <td
                align="right"
                colSpan={6}
                style={{
                  border: "1px solid black",
                  textAlign: "right",
                }}
              >
                Page No: 1 of 1
              </td>
            </tr>
            <tr>
              <td
                align="left"
                colSpan={4}
                style={{
                  border: "1px solid black",
                }}
              >
                Item Name: {ppapData.part_id?.part_name}
              </td>

              <td
                colSpan={2}
                align="left"
                style={{
                  border: "1px solid black",
                }}
              >
                Item No.: {ppapData.part_id?.part_number}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th
                align="center"
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                }}
              >
                S NO.
              </th>
              <th
                align="center"
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                }}
              >
                CHECKING AID USED
              </th>
              <th
                align="center"
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                }}
              >
                RANGE
              </th>
              <th
                align="center"
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                }}
              >
                LEAST COUNT
              </th>
              <th
                align="center"
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                }}
              >
                CALIBRATION FREQ.
              </th>
              <th
                align="center"
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                }}
              >
                REMARKS
              </th>
            </tr>
            {ppapData.checking_aids.map((item, index) => (
              <tr key={item._id}>
                <td
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {item.s_no}
                </td>
                <td
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {item.checking_aid}
                </td>
                <td
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {item.range}
                </td>
                <td
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {item.least_count}
                </td>
                <td
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {item.cali_freq}
                </td>
                <td
                  align="center"
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                  }}
                >
                  {item.remarks}
                </td>
              </tr>
            ))}
          </tbody>
          <tr>
            <td
              colSpan={2}
              style={{
                border: "1px solid black",
              }}
            >
              Issue No.: {ppapData?.check_issue_no}
            </td>
            <td
              colSpan={2}
              style={{
                border: "1px solid black",
              }}
            >
              Prepared By: {ppapData?.check_prepared}
            </td>
            <td
              colSpan={2}
              style={{
                border: "1px solid black",
              }}
            >
              Approved By: {ppapData?.check_approved}
            </td>
          </tr>
        </Table>
      </div>
    </section>
  );
};

export default CheckingAids;
